import { blockedNumberService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { bulkBlockedNumberService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR } from '@/store/helpers';

import {
  ADD_BLOCKED_NUMBER,
  SET_BLOCKED_NUMBERS,
  REMOVE_BLOCKED_NUMBER,
  SEARCH_BULK_BLOCKED_NUMBER,
  REMOVE_BULK_BLOCKED_NUMBER,
  BULK_BLOCK_NUMBERS
} from './mutationTypes';

const actions = {
  async blockNumber({ rootState, commit }, { number }) {
    await blockedNumberService.saveBlockedNumber(rootState.currentAccountId, number).then((blockedNumber) => {
      commit(ADD_BLOCKED_NUMBER, blockedNumber);
    });
  },

  async blockNumbers({ rootState, commit }, numbers) {
    await blockedNumberService.saveMultipleBlockedNumbers(rootState.currentAccountId, numbers).then((blockedNumbers) => {
      blockedNumbers.forEach(blockedNumber => {
        commit(ADD_BLOCKED_NUMBER, blockedNumber);
      });
    });
  },

  async getBlockedNumbers({ commit, rootState }) {
    await blockedNumberService.getBlockedNumbers(rootState.currentAccountId).then(function handleBlockNumbers(blockedNumbers) {
      commit(SET_BLOCKED_NUMBERS, blockedNumbers);
    });
  },

  async unblockNumber({ commit, rootState }, blockedNumberId) {
    await blockedNumberService.deleteBlockedNumber(rootState.currentAccountId, blockedNumberId).then(function () {
      commit(REMOVE_BLOCKED_NUMBER, blockedNumberId);
    });
  },

  async searchBulkBlockedNumber({ rootState, commit }, phoneNumber) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: SEARCH_BULK_BLOCKED_NUMBER });
    try {
      let searchResult = await bulkBlockedNumberService.searchBulkBlockedNumber(rootState.currentAccountId, phoneNumber);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: SEARCH_BULK_BLOCKED_NUMBER });
      commit(SEARCH_BULK_BLOCKED_NUMBER, searchResult);
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: SEARCH_BULK_BLOCKED_NUMBER, error: e });
    }
  },

  async unBlockBulkBlockedNumber({ rootState, commit }, { number, deleteType, campaignId }) {
    commit(REMOVE_BULK_BLOCKED_NUMBER);
    commit(SET_ACTION_STATUS_PENDING, {actionName: REMOVE_BULK_BLOCKED_NUMBER });
    try {
      await bulkBlockedNumberService.unBlockBulkBlockedNumber(rootState.currentAccountId, number, deleteType, campaignId);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: REMOVE_BULK_BLOCKED_NUMBER });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: REMOVE_BULK_BLOCKED_NUMBER, error: e });
    }
    
  },

  async uploadBulkBlockedNumbers({ rootState, commit }, { listToBlock, campaignId }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: BULK_BLOCK_NUMBERS });
    let numbersToBlockString = listToBlock[0];
    listToBlock.shift();
    for (let numberToBlock of listToBlock) {
      numbersToBlockString = numbersToBlockString + ', ' + numberToBlock;
    }
    try {
      let result = await bulkBlockedNumberService.uploadBulkBlockedNumbers(rootState.currentAccountId, numbersToBlockString, campaignId);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: BULK_BLOCK_NUMBERS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: BULK_BLOCK_NUMBERS, error: e });
    }
  },
};

export default actions;